import React from 'react'
import Text from 'react-text'
import Select from 'react-select'
import {Consumer} from '../../context'
import './filters.styl'

function SelectFilter(props) {
  const className = `select-${props.name}`
  return (<Consumer>{ context => {
    const id = context.query[props.valueProperty]
    const value = context[props.name].find(prop => prop.id == id)
    const placeholder = context.translate(`${props.name}_filters_no_options_message`)
    return (
      <div className={className}>
        <div className="dropdown">
          <Select
            className={className}
            classNamePrefix="select"
            formatOptionLabel = {({name}) => name}
            isSearchable = {false}
            isClearable = {true}
            escapeClearsValue = {true}
            getOptionValue = {({id}) => id}
            placeholder = {placeholder}
            value = {value}
            onChange = {option => {
              const {id} = option || {}
              const query = {[props.valueProperty]: id, page: undefined}
              context.navigate({}, context.match.path, {preserveQuery: true, query})
            }}
            options = {context[props.name]}
          />
        </div>
      </div>
    )
  }}</Consumer>)
}

export default function Filters () {
  return (
    <div className="filters-wrapper">
      <div className="filters">
        <SelectFilter name="subjects" valueProperty="subject" />
        <SelectFilter name="grades" valueProperty="grade" />
        <SelectFilter name="languages" valueProperty="languageId" />
      </div>
    </div>
  )
}
